import { config } from '@/config'
import { useNotificationStore } from '@/store/notification'
import Axios from 'axios'

export const axios = Axios.create({
  baseURL: config.apiUrl,
})

axios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.log(error.message)
    const message = error.response?.data.message || error.mesage

    useNotificationStore.getState().addNotifcation({
      title: 'Something went wrong',
      message: message,
      type: 'error',
    })
    return Promise.reject(error)
  }
)
